export const invoicesBackups = {
	title: "Backups",
	description: "Arquivos de notas ficais emitidas por mês.",
	filters: {
		fiscalProfile: {
			label: "Perfil fiscal",
			placeholder: "Busque por perfil fiscal",
		},
	},
	table: {
		fiscalProfile: "Perfil fiscal",
		month: "Mês",
		files: "Arquivos",
		downloadDanfes: "Download de DANFEs",
		downloadXmls: "Download de XMLs",
		unavaliable: "indisponível",
	},
};
